import { useEffect, useState } from 'react';
import { Firma, Pantalla, Pasos } from './ui.js';

/**
 * El frame VERIFICANDO del Figma: paso 3 de 3, el anillo con el porcentaje.
 *
 * ── EL PORCENTAJE ES UNA ESPERA REAL, NO UN TEATRO ─────────────────────────────
 *
 * Esta pantalla se muestra MIENTRAS una petición de verdad está en vuelo (los gestos van
 * camino del servidor). El número sube rápido al principio y se frena acercándose a 90 —
 * asintótico, nunca llega — y solo la respuesta real lo completa. Es el patrón honesto para
 * una espera de duración desconocida: comunica "estamos trabajando" sin inventarse un final.
 *
 * Lo que sería teatro es mostrarla sin petición detrás, con un temporizador que llega a 100
 * y pasa a la siguiente pantalla solo. Eso está prohibido aquí: si no hay nada que esperar,
 * esta pantalla no se muestra. (Es la razón de que en el flujo actual dure poco: la única
 * espera real es `/gestos`. Cuando #79 suba fotogramas y encienda /pulse y /prnu, esta misma
 * pantalla cubrirá esa espera, que sí es larga.)
 */

const RADIO = 84;
const CIRCUNFERENCIA = 2 * Math.PI * RADIO;

export function Verificando() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    // Asintótico: cada tick recorre el 4% de lo que falta hasta 90. Rápido al arrancar,
    // lento al final, jamás completo — completarlo es privilegio de la respuesta real,
    // que desmonta esta pantalla.
    const t = setInterval(() => {
      setPct((p) => p + (90 - p) * 0.04);
    }, 120);
    return () => clearInterval(t);
  }, []);

  const entero = Math.round(pct);
  const visible = (pct / 100) * CIRCUNFERENCIA;

  return (
    <Pantalla>
      <Pasos paso={3} />

      <div className="flex flex-1 flex-col items-center justify-center px-8 text-center">
        <div className="relative" style={{ width: 220, height: 220 }}>
          <svg width="220" height="220" viewBox="0 0 220 220" className="-rotate-90">
            <circle cx="110" cy="110" r={RADIO} fill="none" stroke="rgba(51,50,242,.12)" strokeWidth="14" />
            <circle
              cx="110"
              cy="110"
              r={RADIO}
              fill="none"
              stroke="url(#degradado-anillo)"
              strokeWidth="14"
              strokeLinecap="round"
              strokeDasharray={`${visible} ${CIRCUNFERENCIA}`}
              style={{ transition: 'stroke-dasharray 140ms linear' }}
            />
            <defs>
              <linearGradient id="degradado-anillo" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="var(--acento, #3332f2)" />
                <stop offset="100%" stopColor="var(--acento-2, #6b5cff)" />
              </linearGradient>
            </defs>
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-[40px] font-bold leading-none">{entero}%</span>
            <span className="mt-1 text-[13px]" style={{ color: 'rgba(16,17,20,.5)' }}>
              Analizando…
            </span>
          </div>
        </div>

        <h1 className="mt-9 text-[24px] font-bold">Verificando identidad</h1>
        <p className="mt-1.5 text-[13.5px]" style={{ color: 'rgba(16,17,20,.55)' }}>
          No cierres esta ventana
        </p>
      </div>

      <Firma />
    </Pantalla>
  );
}
